function setOrderTypes(state, orderTypes) {
	state.orderTypes = orderTypes;
}

export default { setOrderTypes };